var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _WarpMarkerBoxAdapter_instances, _WarpMarkerBoxAdapter_terminator, _WarpMarkerBoxAdapter_context, _WarpMarkerBoxAdapter_box, _WarpMarkerBoxAdapter_notifer, _WarpMarkerBoxAdapter_isSelected, _WarpMarkerBoxAdapter_onChanged;
import { Notifier, Terminator } from "@opendaw/lib-std";
import { Propagation } from "@opendaw/lib-box";
import { AudioPlayMode } from "./AudioPlayMode";
export class WarpMarkerBoxAdapter {
    constructor(context, box) {
        _WarpMarkerBoxAdapter_instances.add(this);
        this.type = "warp-marker";
        _WarpMarkerBoxAdapter_terminator.set(this, new Terminator());
        _WarpMarkerBoxAdapter_context.set(this, void 0);
        _WarpMarkerBoxAdapter_box.set(this, void 0);
        _WarpMarkerBoxAdapter_notifer.set(this, void 0);
        _WarpMarkerBoxAdapter_isSelected.set(this, false);
        __classPrivateFieldSet(this, _WarpMarkerBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _WarpMarkerBoxAdapter_box, box, "f");
        __classPrivateFieldSet(this, _WarpMarkerBoxAdapter_notifer, new Notifier(), "f");
        __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_terminator, "f").own(box.subscribe(Propagation.Children, () => __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_instances, "m", _WarpMarkerBoxAdapter_onChanged).call(this)));
    }
    onSelected() {
        __classPrivateFieldSet(this, _WarpMarkerBoxAdapter_isSelected, true, "f");
        this.optWarping.ifSome(warping => warping.onChanged());
        __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_instances, "m", _WarpMarkerBoxAdapter_onChanged).call(this);
    }
    onDeselected() {
        __classPrivateFieldSet(this, _WarpMarkerBoxAdapter_isSelected, false, "f");
        __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_instances, "m", _WarpMarkerBoxAdapter_onChanged).call(this);
    }
    get box() { return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_box, "f").address; }
    get position() { return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_box, "f").position.getValue(); }
    get seconds() { return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_box, "f").seconds.getValue(); }
    get isSelected() { return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_isSelected, "f"); }
    get optWarping() {
        return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_box, "f").owner.targetVertex
            .map(vertex => __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_context, "f").boxAdapters.adapterFor(vertex.box, AudioPlayMode.isAudioPlayMode));
    }
    get isAnchor() {
        return this.optWarping.mapOr(({ warpMarkers }) => this === warpMarkers.optAt(0) || this === warpMarkers.optAt(warpMarkers.length() - 1), false);
    }
    subscribe(observer) { return __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_notifer, "f").subscribe(observer); }
    terminate() { __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_terminator, "f").terminate(); }
}
_WarpMarkerBoxAdapter_terminator = new WeakMap(), _WarpMarkerBoxAdapter_context = new WeakMap(), _WarpMarkerBoxAdapter_box = new WeakMap(), _WarpMarkerBoxAdapter_notifer = new WeakMap(), _WarpMarkerBoxAdapter_isSelected = new WeakMap(), _WarpMarkerBoxAdapter_instances = new WeakSet(), _WarpMarkerBoxAdapter_onChanged = function _WarpMarkerBoxAdapter_onChanged() {
    __classPrivateFieldGet(this, _WarpMarkerBoxAdapter_notifer, "f").notify();
    this.optWarping.ifSome(warping => warping.onChanged());
};
